import { logger } from "./logger";
import { isVideoContent, type Spot } from "$lib/elev8Api/contentTypes";

async function requestSwCacheVideo(url: string): Promise<void> {
  if (!("serviceWorker" in navigator)) {
    logger.warn(
      "[CacheHelpers] requestSwCacheVideo - No service worker available"
    );
    return;
  }

  const registration = await navigator.serviceWorker.ready;
  registration.active?.postMessage({
    type: "CACHE_VIDEO",
    url,
  });
}

export async function requestSwCacheVideos(loop: Spot[]) {
  const urls = new Set(
    loop.flatMap((spot) =>
      spot.contents.filter(isVideoContent).map((content) => content.asset_url)
    )
  );
  await Promise.all([...urls].map(requestSwCacheVideo));
  logger.debug(`[CacheHelpers] requestSwCacheVideos (${urls.size} requests)`);
}
